import React from 'react'

const FeedBack = () => {
  return (
    <div>FeedBack</div>
  )
}

export default FeedBack